import { Component, EventEmitter, Output, Renderer2 } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TuiTime } from '@taiga-ui/cdk';
import { tuiCreateTimePeriods } from '@taiga-ui/kit';
import { firstValueFrom } from 'rxjs';
import { HistoryServicesService } from 'src/app/services/history-services/history-services.service';
import { PoolManagerService } from 'src/app/services/pool-manager/pool-manager.service';
declare var moment: any;

@Component({
  selector: 'app-emergencies-table',
  templateUrl: './emergencies-table.component.html',
  styleUrls: ['./emergencies-table.component.css'],
})
export class EmergenciesTableComponent {
  index: number = 0;
  length: number = 0;
  pageSize: number = 50;
  filterDisabled: boolean = false;
  searchTerm: string = '';
  poolServices: any = [];
  selectedDate: any = [
    new Date(),
    new Date(new Date().setDate(new Date().getDate() + 30)),
  ];
  zones!: any[];
  selectedZone!: any;
  products!: any[];
  selectedProduct: any = [];
  allClients: any[] = [];
  allDrivers: any;
  selectedDriver: any = [];
  communication_states: any[] = [
    { id: 1, name: 'Sin contactar', count: 0, color: '' },
    { id: 2, name: 'Incidencia llamada telefónica', count: 0 },
    { id: 3, name: 'SMS', count: 0 },
    { id: 4, name: 'SMS Enviado', count: 0, color: 'lightblue' },
    { id: 5, name: 'Error SMS', count: 0, color: 'lightpink' },
    { id: 6, name: 'Whatsapp', count: 0 },
    { id: 7, name: 'Pendiente de respuesta', count: 0, color: 'lightyellow' },
    { id: 8, name: 'Sí respuesta', count: 0, color: 'lightgreen' },
    { id: 9, name: 'No respuesta +60min', count: 0, color: 'lightorange' },
    { id: 10, name: 'Error envío', count: 0, color: 'lightcoral' },
  ];
  selectedClient: any = [];
  datesArray: any[] = [];
  selectedOrderStatus: any = [];
  selectedCommunication: any = [];
  startTimeItems: TuiTime[] = this.generateTimeItems();
  endTimeItems: TuiTime[] = [];
  orderStatus = [
    { statusName: 'Inicializado', orderStatus: 'INITIALIZED' },
    { statusName: 'Pendiente', orderStatus: 'PENDING' },
    { statusName: 'Confirmado', orderStatus: 'CONFIRMED' },
    { statusName: 'Recogiendo', orderStatus: 'PICKING_UP' },
    { statusName: 'En proceso', orderStatus: 'IN_PROGRESS' },
    { statusName: 'Entregando', orderStatus: 'DELIVERING' },
    { statusName: 'Finalizado', orderStatus: 'FINISHED' },
    { statusName: 'Fallado', orderStatus: 'FAILED' },
    { statusName: 'Cancelado por Cafler', orderStatus: 'CANCELLED_BY_CAFLER' },
    { statusName: 'Cancelado por cliente', orderStatus: 'CANCELLED_BY_CLIENT' },
  ];
  filterCount: number = 0;
  @Output() countEvent = new EventEmitter<string>();
  sortDirection!: any;
  sortedColumn: string = '';
  readonly sizes = ['l', 'm', 's'] as const;
  size = this.sizes[0];
  paginatedData: any[] = [];
  readonly hourForm = this.fb.group({
    startTime: [null as TuiTime | null],
    endTime: [null as TuiTime | null],
  });

  div_loder = document.getElementById('loader');
  readonly columns = [
    'date',
    'time',
    'licensePlate',
    'orderHash',
    'zone',
    'product',
    'topping',
    'client',
    'status',
    'driver',
    'price',
    'activeBid',
    'communication',
    'actions',
  ];
  constructor(
    private poolManagerSvc: PoolManagerService,
    public historyServicesSvc: HistoryServicesService,
    private renderer: Renderer2,
    private fb: FormBuilder
  ) {}

  async ngOnInit(): Promise<any> {
    const response: any = await firstValueFrom(this.poolManagerSvc.getZones());
    this.zones = response.zones;

    this.hourForm.get('startTime')?.valueChanges.subscribe((startTime: any) => {
      if (startTime) {
        this.endTimeItems = this.generateTimeItems().filter(
          (time) =>
            time.toAbsoluteMilliseconds() > startTime.toAbsoluteMilliseconds()
        );

        const endTime = this.endTimeItems[0] || null;
        this.hourForm.get('endTime')?.setValue(endTime, { emitEvent: false });
      } else {
        this.endTimeItems = this.generateTimeItems();
        this.hourForm.get('endTime')?.setValue(null, { emitEvent: false });
      }
    });
  }

  showLoader() {
    if (this.div_loder) {
      this.renderer.setStyle(this.div_loder, 'display', 'flex');
    }
  }

  hideLoader() {
    if (this.div_loder) {
      this.renderer.setStyle(this.div_loder, 'display', 'none');
    }

    setTimeout(() => {
      const closeDiv = document.querySelector('.t-close');
      if (closeDiv) {
        (closeDiv as HTMLElement).click();
      }
    }, 5000);
  }

  funcionKeyUp(searchText: string) {
    this.searchTerm = searchText;
  }
  async filterDataBySelect(index?: any) {
    this.paginatedData = this.poolServices;
    this.index = index ?? 0;
    this.products = [
      ...new Set(
        this.poolServices.map((item: any) =>
          this.historyServicesSvc.translate(item.mainProductName)
        )
      ),
    ];

    if (
      !this.searchTerm &&
      this.selectedClient.length === 0 &&
      this.selectedProduct.length === 0 &&
      this.selectedDriver.length === 0 &&
      this.selectedOrderStatus.length === 0 &&
      !this.hourForm.value.startTime &&
      !this.hourForm.value.endTime
    ) {
      this.sortByExec();
      this.applyPagination();
      return;
    }

    const search = this.searchTerm ? this.searchTerm.toLowerCase() : '';
    this.paginatedData = this.poolServices.filter((item: any) => {
      const license = item.licensePlate.toLowerCase();
      const orderHash = item.orderHash.toLowerCase();
      const clientName = item.clientName.toLowerCase();
      const driverName = item.driverName
        ? item.driverName.toLowerCase()
        : 'Sin asignar';

      const matchesSearch =
        !this.searchTerm ||
        license.includes(search) ||
        orderHash.includes(search) ||
        clientName.includes(search) ||
        driverName.includes(search);

      const matchesClient =
        this.selectedClient.length === 0 ||
        this.selectedClient.includes(item.clientName);

      const matchesStatus =
        this.selectedOrderStatus.length === 0 ||
        this.selectedOrderStatus.includes(item.orderStatus);

      const matchesProduct =
        this.selectedProduct.length === 0 ||
        this.selectedProduct.includes(
          this.historyServicesSvc.translate(item.mainProductName)
        );

      return matchesSearch && matchesClient && matchesProduct && matchesStatus;
    });


    if (this.hourForm.value.startTime && this.hourForm.value.endTime) {
      const formattedStartTime = this.formatTimeToHHMM(
        this.hourForm.value.startTime
      );
      const formattedEndTime = this.formatTimeToHHMM(
        this.hourForm.value.endTime
      );
      this.paginatedData = this.filterByTimeRange(
        this.paginatedData,
        formattedStartTime,
        formattedEndTime
      );
    }
    this.sortByExec();
    this.applyPagination();
  }
  filterByTimeRange(data: any, startTime: any, endTime: any) {
    const startMinutes = this.convertTimeToMinutes(startTime);
    const endMinutes = this.convertTimeToMinutes(endTime);

    return data.filter((item: any) => {
      const itemStartMinutes = this.convertTimeToMinutes(
        item.serviceStartDate.time.split(':').slice(0, 2).join(':')
      );
      const itemEndMinutes = this.convertTimeToMinutes(
        item.serviceEndDate.time.split(':').slice(0, 2).join(':')
      );

      return (
        (itemStartMinutes >= startMinutes && itemStartMinutes <= endMinutes) ||
        (itemEndMinutes >= startMinutes && itemEndMinutes <= endMinutes) ||
        (itemStartMinutes <= startMinutes && itemEndMinutes >= endMinutes)
      );
    });
  }
  convertTimeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  formatTimeToHHMM(time: { hours: number; minutes: number }): string {
    const hours = String(time.hours).padStart(2, '0');
    const minutes = String(time.minutes).padStart(2, '0');

    return `${hours}:${minutes}`;
  }
  sortByExec(): void {

    this.paginatedData = [...this.paginatedData].sort((a, b) => {
      const valueA = a[this.sortedColumn];
      const valueB = b[this.sortedColumn];

      if (valueA < valueB) {
        return -this.sortDirection;
      }
      if (valueA > valueB) {
        return this.sortDirection;
      }
      return 0;
    });

  }

  applyPagination() {
    this.length = Math.ceil(this.paginatedData.length / this.pageSize);

    if (this.length === 1) {
      this.index = 0;
    }
    this.filterCount = this.paginatedData.length;
    this.sendNumberOfServices(this.filterCount);
    const start = this.index * this.pageSize;
    this.paginatedData = this.paginatedData.slice(start, start + this.pageSize);
  }

  async filterDataByDate() {
    this.showLoader();

    if (!this.allClients) {
      this.historyServicesSvc.getClients().subscribe((res: any) => {
        this.allClients = res.businessUserData;
      });
    }

    if (this.selectedDate && this.selectedZone) {
      this.poolServices = [];
      this.paginatedData = [];
      const localDate = moment(this.selectedDate);

      const start = moment.utc({
        year: localDate.year(),
        month: localDate.month(),
        date: localDate.date(),
        hour: localDate.hour(),
        minute: localDate.minute(),
        second: localDate.second(),
      });
      let currentDate = start;
      while (this.datesArray.length < 30) {
        this.datesArray.push(currentDate.unix());
        currentDate = currentDate.add(1, 'days');
      }

      for (let i = 0; i < this.datesArray.length; i++) {
        this.filterDisabled = true;
        const element = this.datesArray[i];
        const poolData = {
          date: { seconds: element },
          zoneId: this.selectedZone,
        };

        try {
          const res: any = this.poolManagerSvc.getPaginatedFreelancePoolServices();

          if (res.services) {
            const poolData = res.services;
            poolData.forEach((pool: any) => {
              let textDateStart = pool.serviceStartDate.time.split(':');
              let textDateEnd = pool.serviceEndDate.time.split(':');

              pool.startHour = textDateStart[0] + ':' + textDateStart[1];
              pool.endHour = textDateEnd[0] + ':' + textDateEnd[1];

              pool.zoneName = this.getZone(pool.zoneId);

              let textDateService =
                pool.serviceStartDate.completeDate.split('T');
              let dateService = moment(textDateService[0]);
              pool.formattedDate = dateService.format('DD/MM/YYYY');
              this.poolServices.push(pool);
            });
          }
        } catch (error) {
          console.error('Error fetching services', error);
        }

        this.paginatedData = this.poolServices;
        const inputElement: any = document.getElementById('searchInput');
        inputElement.value = '';
        this.searchTerm = '';
        this.selectedClient = [];
        this.selectedProduct = [];
        this.selectedDriver = [];
        this.selectedOrderStatus = [];
        this.products = [
          ...new Set(
            this.poolServices.map((item: any) =>
              this.historyServicesSvc.translate(item.mainProductName)
            )
          ),
        ];
        this.allClients = [
          ...new Set(this.poolServices.map((item: any) => item.clientName)),
        ];

        this.length = Math.ceil(this.paginatedData.length / this.pageSize);
        if (this.length == 1) {
          this.index = 0;
        }

        this.filterCount = this.paginatedData.length;
        this.sendNumberOfServices(this.filterCount);
        const start = this.index * this.pageSize;
        this.paginatedData = this.paginatedData.slice(
          start,
          start + this.pageSize
        );
      }
      this.filterDisabled = false;
    }
    this.hideLoader();
  }

  setSortColumn(column: string): void {
    if (this.sortedColumn === column) {
      this.sortDirection = this.sortDirection == -1 ? 1 : -1;
    } else {
      this.sortedColumn = column;
      this.sortDirection = -1;
    }
    this.sortData();
  }
  private generateTimeItems(): TuiTime[] {
    const items: TuiTime[] = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 60; minutes += 15) {
        items.push(new TuiTime(hours, minutes));
      }
    }
    return items;
  }
  sortData(): void {
    this.filterDataBySelect(this.index);
  }
  onSort(event: any): void {
    this.sortDirection = event;
  }
  goToPage(pageIndex: number) {
    this.index = pageIndex;
    this.filterDataBySelect(pageIndex);
  }
  getClientById(id: any) {
    let client_info = this.allClients.find((item: any) => item.userId === id);
    return client_info ? client_info.businessName : null;
  }
  getZone(zoneId: string) {
    const selectedZone = this.zones.find((zone) => zone.zoneId === zoneId);

    return selectedZone.zoneName;
  }

  sendNumberOfServices(number: number) {
    this.countEvent.emit(number.toString());
  }
}
